// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.comandi-box {
  border: 1px solid var(--ion-color-light-shade, #e3e7ee);
  border-radius: 10px;
  background: var(--ion-color-light, #f8fafc);
  font-size: 13px;
  overflow: hidden;
}

.comandi-box__titolo {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-bottom: 1px solid var(--ion-color-light-shade, #e3e7ee);
}
.comandi-box__titolo b {
  flex: 1;
}

.comandi-box__conteggio {
  color: var(--ion-color-medium);
}

.comandi-riepilogo {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  margin-bottom: 6px;
  border: 1px solid var(--ion-color-light-shade, #e3e7ee);
  border-radius: 14px;
  background: var(--ion-color-light, #f8fafc);
  color: var(--ion-text-color, #374151);
  font: inherit;
  font-size: 12px;
  cursor: pointer;
}

.comando {
  display: flex;
  gap: 10px;
  padding: 8px 12px;
  align-items: flex-start;
}

.comando--in-corso {
  background: rgba(var(--ion-color-primary-rgb, 56, 128, 255), 0.08);
}

.comando__icona {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  margin-top: 2px;
}

.comando__corpo {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.comando__durata {
  color: var(--ion-color-medium);
}

.comando__durata--in-corso {
  color: var(--ion-color-primary);
}

.comando__codice {
  font-size: 12px;
  color: var(--ion-color-medium-shade);
  overflow-wrap: anywhere;
}

.comando__errore {
  font-size: 12px;
  color: var(--ion-color-danger);
}`, "",{"version":3,"sources":["webpack://./src/app/_components/ai-chat/ai-chat-comandi/ai-chat-comandi.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE,uDAAA;EACA,mBAAA;EACA,2CAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,8DAAA;AACF;AACE;EACE,OAAA;AACJ;;AAGA;EACE,8BAAA;AAAF;;AAGA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,uDAAA;EACA,mBAAA;EACA,2CAAA;EACA,qCAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;AAAF;;AAGA;EACE,aAAA;EACA,SAAA;EACA,iBAAA;EACA,uBAAA;AAAF;;AAGA;EACE,kEAAA;AAAF;;AAGA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAAF;;AAGA;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAAF;;AAGA;EACE,8BAAA;AAAF;;AAGA;EACE,+BAAA;AAAF;;AAGA;EACE,eAAA;EACA,oCAAA;EACA,uBAAA;AAAF;;AAGA;EACE,eAAA;EACA,8BAAA;AAAF","sourcesContent":[":host {\n  display: block;\n}\n\n.comandi-box {\n  border: 1px solid var(--ion-color-light-shade, #e3e7ee);\n  border-radius: 10px;\n  background: var(--ion-color-light, #f8fafc);\n  font-size: 13px;\n  overflow: hidden;\n}\n\n.comandi-box__titolo {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  border-bottom: 1px solid var(--ion-color-light-shade, #e3e7ee);\n\n  b {\n    flex: 1;\n  }\n}\n\n.comandi-box__conteggio {\n  color: var(--ion-color-medium);\n}\n\n.comandi-riepilogo {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  margin-bottom: 6px;\n  border: 1px solid var(--ion-color-light-shade, #e3e7ee);\n  border-radius: 14px;\n  background: var(--ion-color-light, #f8fafc);\n  color: var(--ion-text-color, #374151);\n  font: inherit;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.comando {\n  display: flex;\n  gap: 10px;\n  padding: 8px 12px;\n  align-items: flex-start;\n}\n\n.comando--in-corso {\n  background: rgba(var(--ion-color-primary-rgb, 56, 128, 255), 0.08);\n}\n\n.comando__icona {\n  flex-shrink: 0;\n  width: 16px;\n  height: 16px;\n  margin-top: 2px;\n}\n\n.comando__corpo {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.comando__durata {\n  color: var(--ion-color-medium);\n}\n\n.comando__durata--in-corso {\n  color: var(--ion-color-primary);\n}\n\n.comando__codice {\n  font-size: 12px;\n  color: var(--ion-color-medium-shade);\n  overflow-wrap: anywhere;\n}\n\n.comando__errore {\n  font-size: 12px;\n  color: var(--ion-color-danger);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
